export function headerAnimationHandler() {
    const $body = $("body");
    const $window = $(window);
    const $header = $(".main-header");

    let lastScrollTop = $window.scrollTop() > 0 ? $window.scrollTop() : 0;
    let viewPortHeight = $window.outerHeight();
    let headerHeight = $header.outerHeight();
    let allowHeaderAnimation = false;
    let headerPos = 0;
    let firstScroll = false;

  //  $window.on("load", () => {
        allowHeaderAnimation = $body.hasClass("no-touch");
        lastScrollTop = $window.scrollTop() > 0 ? $window.scrollTop() : 0;

        if (allowHeaderAnimation && $window.scrollTop() > headerHeight) {
            $header.addClass("header-fixed");
            $header.css({
                "position": "fixed",
                "top": -headerHeight
            });

            headerPos = -headerHeight;
            // console.log("headerHeight", headerHeight);
        }

        $window.scroll(function (event) {
            firstScroll = true;

            headerHeight = $header.outerHeight();

            if (firstScroll) {
                if (allowHeaderAnimation) {
                    let st = $(this).scrollTop();
                    if (st > lastScrollTop) {
                        $(".language-switcher").removeClass("active");
                        if (!$header.hasClass("header-fixed")) {
                            if (st > headerHeight) {
                                $header.addClass("header-fixed");
                                $header.css({
                                    //"position": "fixed",
                                    "top": -headerHeight
                                });
                                headerPos = -headerHeight;

                                // console.log("headerPos after fixed", headerPos);
                            }
                        } else {
                            // console.log("DOWN isFixed headerPos", headerPos);
                            if (headerPos <= 0) {
                                headerPos -= (st - lastScrollTop);

                                if (headerPos <= -headerHeight) headerPos = -headerHeight;

                                $header.css({
                                    "top": headerPos
                                });
                            }
                        }

                    } else if (st == lastScrollTop) {
                        //do nothing 
                        //In IE this is an important condition because there seems to be some instances where the last scrollTop is equal to the new one
                    } else {
                        // console.log("up");

                        if (st === 0) {
                            $header.removeClass("header-fixed");
                            $header.css({
                                //"position": "absolute",
                                "top": 0
                            });

                            headerPos = 0;
                        }

                        if ($header.hasClass("header-fixed")) {
                            if (st <= headerHeight) {
                                $header.removeClass("header-fixed");
                                $header.css({
                                    "top": 0
                                });

                                if (st === 0) {
                                    $header.css({
                                        //"position": "absolute",
                                        "top": 0
                                    });

                                    headerPos = 0;
                                }
                            }

                            if (headerPos < 0 && st > headerHeight) {

                                headerPos += (lastScrollTop - st);

                                if (headerPos > 0) headerPos = 0;

                                $header.css({
                                    "top": headerPos
                                });
                            }
                        }
                    }

                    lastScrollTop = st;
                } else {
                    console.log(2);
                    let st = $(this).scrollTop();
                    if (st > 0) {
                        $header.addClass("fixed");
                    } else {
                        $header.removeClass("fixed");
                    }
                }
            }
        });
   // });

    // window.addEventListener("resize", () => {
    //     setTimeout(() => {
    //         allowHeaderAnimation = $window.outerWidth() >= 768;
    //         headerHeight = $header.outerHeight();
    //         if (allowHeaderAnimation) {
    //             if ($window.scrollTop > headerHeight) {
    //                 $header.addClass("header-fixed");
    //                 $header.css({
    //                     "position": "fixed",
    //                     "top": -headerHeight
    //                 });
    //                 headerPos = -headerHeight;
    //             }
    //         }
    //     }, 100);
    // });
}


// WEBPACK FOOTER //
// ./assets/js/modules/header.js